<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="container container-my-focus">
      <asideCom :activityIndex="3"></asideCom>
      <div class="my-content">
        <div class="top-choose">
          <div class="message" :class="{'choose':contentIndex===0}" @click="changeIndex(0)">{{$t('global.创作者')}}</div>
          <span>|</span>
          <div
            class="modify-password"
            :class="{'choose':contentIndex===1}"
            @click="changeIndex(1)"
          >{{$t('global.企业号')}}</div>
        </div>
        <div class="select-wrap">
          <div class="identification-select">
            <span>{{$t('global.认证')}}：</span>
            <select v-model="isCertification" @change="followList(1)">
              <option value="1">{{$t('global.认证')}}</option>
              <option value="2">{{$t('global.非认证')}}</option>
            </select>
          </div>
          <div class="area-select">
            <span>{{$t('global.地区')}}：</span>
            <select v-model="area" @change="followList(1)">
              <option v-for="(item,index) in areaList" :key="index" :value="item">{{item}}</option>
            </select>
          </div>
        </div>
        <AuthorList @follow="follow" :itemList="list" :small="false" v-if="list.length > 0"></AuthorList>
        <content-empty v-else-if="list.length === 0" :content="content"></content-empty>
        <pages
          v-if="list.length > 0"
          :page-size="pagerParam.pageSize"
          :page-count="pagerParam.pageCount"
          :current-page.sync="pagerParam.currentPage"
          :total="pagerParam.total"
          @current-page-changed="OnCurrentPageChanged"
        ></pages>
      </div>
    </div>
    <service></service>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import service from "@/components/service.vue";
import asideCom from "@/components/aside.vue";
import pages from "@/components/pages.vue";
import ContentEmpty from "@/components/ContentEmpty.vue";
import AuthorList from "@/components/author/AuthorList";

export default {
  name: "manageVideo",
  metaInfo() {
    return {
      title: this.$t("global.我的关注") + " | MANA"
    };
  },
  data() {
    return {
      contentIndex: 0,
      list: [],
      area: "",
      areaList: [],
      isCertification: "",
      pagerParam: {
        pageSize: 20,
        pageCount: 1,
        currentPage: 1,
        total: 1
      }
    };
  },
  components: {
    MainLayout,
    service,
    asideCom,
    pages,
    ContentEmpty,
    AuthorList
  },
  computed: {
    content() {
      if (this.contentIndex === 0) {
        return this.$t('global.没有关注的创作者');
      } else if (this.contentIndex === 1) {
        return this.$t('global.没有关注的企业号');
      }
    }
  },
  created() {
    this.areaListF();
    this.followList();
  },
  methods: {
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.followList();
    },
    changeIndex(index) {
      this.contentIndex = index;
      this.followList(1);
    },
    follow(item) {
      let index = this.list.findIndex(n => n.userId === item.userId);
      this.list.splice(index, 1);
      this.$forceUpdate();
    },
    followList(pageI) {
      this.$http
        .get("/api/u/relation/followList", {
          params: {
            userType: this.contentIndex + 1,
            isCertification: this.isCertification,
            area: this.area,
            pageIndex: pageI || this.pagerParam.currentPage
          }
        })
        .then(response => {
          let data = response.data;
          this.list = data.list;
          this.pagerParam.total = data.totalRecord;
          this.pagerParam.pageCount = data.totalPage;
          this.pagerParam.currentPage = data.pageIndex;
          this.pagerParam.pageSize = data.pageSize;
        });
    },
    areaListF() {
      this.$http.get("/api/u/relation/areaList").then(response => {
        this.areaList = response.data;
      });
    },
    gotoVideo(videoId) {
      this.$router.push("/Video/detail?id=" + videoId);
    },
    gotoHomePage(userId) {
      this.$router.push("/peopleCenter/" + userId);
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.people-production {
  display: flex;
  width: 10.8rem;
  margin: 0 auto;
  border-bottom: 1px solid #dddddd;
  justify-content: space-between;
  padding: 0.41rem 0 0.47rem 0;
}

.production-body {
  display: flex;
  flex-wrap: wrap;

  img {
    display: block;
    width: 2.06rem;
    height: 1.16rem;
    margin: 0.1rem 0 0 0.1rem;
    border-radius: 0.08rem;
    cursor: pointer;
  }
}

.head {
  display: flex;

  img {
    width: 1.3rem;
    height: 1.3rem;
  }

  .description {
    width: 1.8rem;
    margin-left: 0.3rem;
  }

  .peopleHome {
    width: 1.2rem;
    height: 0.41rem;
    line-height: 0.41rem;
    margin-top: 0.12rem;
    color: #ffffff;
    text-align: center;
    text-indent: 0;
    font-size: 0.16rem;
    background-color: #dddddd;
    border-radius: 0.2rem;
  }

  .profession {
    font-size: 0.16rem;
    color: #777777;
    margin-top: 0.12rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .name {
    color: #333333;
    font-size: 0.2rem;
  }
}

.select-wrap {
  display: flex;
  font-size: 0.16rem;
  color: #999999;
  margin-top: 0.45rem;

  .area-select {
    margin-left: 0.38rem;
  }
}

.my-content {
  width: 790px;
  background-color: #ffffff;
  padding: 40px;
  border-radius: 0.08rem;

  .top-choose {
    display: flex;
    justify-content: center;
    font-size: 0.26rem;
    color: #707070;

    div {
      cursor: pointer;
    }

    span {
      display: block;
      margin: 0 0.65rem;
    }

    .choose {
      color: #333333;
      font-weight: bold;
    }
  }
}

.container {
  margin: 40px auto;
  display: flex;
  width: 1160px;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/account/Focus.vue